<template>
  <RecruiterActionMenu
    :hire-id="column.id"
    :recruiter-id="recruiterId"
    :status="column.status"
    :manages-workers="column.recruiterManagesWorkers ?? false"
    :contract="column.latestContract"
    :conversation="column.conversation?.viewerCanAccess ? column.conversation : null"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import RecruiterActionMenu from '@/components/RecruiterPlacements/RecruiterActionMenu.vue'

const RecruiterPlacementActionColumn = graphql(`
  fragment RecruiterPlacementActionColumn on Hire {
    id
    status
    recruiterManagesWorkers
    latestContract {
      id
      status
      pdfUrl
      workerAcceptedAt
    }
    conversation {
      url
      viewerCanAccess
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof RecruiterPlacementActionColumn> }>()
const column = computed(() => useFragment(RecruiterPlacementActionColumn, props.row))

const recruiterId = currentAccount.globalId
</script>
